import { useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';

export interface DisclosureState {
  open: boolean;
  seen: string[];
}

export interface DisclosureMemory {
  key: string;
  read: () => DisclosureState | undefined;
  write: (state: DisclosureState) => void;
}

/** UI state only, cleared by the same account/location purge as tenant queries. */
export function useSuggestionDisclosureMemory(scope: string, target: string): DisclosureMemory {
  const client = useQueryClient();
  return useMemo(() => {
    const queryKey = ['suggestion-disclosure-state', scope, target];
    return {
      key: JSON.stringify(queryKey),
      read: () => client.getQueryData<DisclosureState>(queryKey),
      write: (state) => {
        // Keep a manual close for this access scope even after the conversation
        // query's normal cache lifetime. Session purges remove this entry too.
        client.setQueryDefaults(['suggestion-disclosure-state'], { gcTime: Infinity });
        client.setQueryData(queryKey, state);
      },
    };
  }, [client, scope, target]);
}
